module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DaiJia"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.daijiaBanner && _vm.daijiaBanner.length > 0) ? _c('div', {
    staticClass: "banner"
  }, [_c('xk-roll-banner', {
    attrs: {
      "data": _vm.daijiaBanner
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "setSite"
  }, [_c('div', {
    staticClass: "typeNav"
  }, [(_vm.typeAll.data.length > 0) ? _c('xk-type-tabs', {
    attrs: {
      "cardata": _vm.typeAll,
      "defaultmum": 0
    },
    on: {
      "click": _vm.typeTabFn
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        “附近有 "), _c('span', {
    staticStyle: {
      "color": "#f06553"
    }
  }, [_vm._v(_vm._s(_vm.getNearDrivers.length || 0))]), _vm._v(" 位司机候驾”\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row row1 clear"
  }, [_c('i', {
    staticClass: "iconfont icon-yuan"
  }), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_c('xk-site-input', {
    attrs: {
      "placeholder": "请输入起点位置",
      "name": _vm.positioning ? _vm.positioning.name : '',
      "state": true
    },
    on: {
      "onClick": _vm.startCityFn
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row2 clear"
  }, [_c('i', {
    staticClass: "iconfont icon-yuan"
  }), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_c('xk-site-input', {
    attrs: {
      "placeholder": "请输入终点位置",
      "checkedlogin": "",
      "name": _vm.adds.endAdd.endAddress,
      "addressrecord": _vm.addressRecordFn,
      "state": true
    },
    on: {
      "onClick": _vm.endCityFn
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row3 clear"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "list",
    class: _vm.others.othersPhone !== '' ? 'listAc' : '',
    staticStyle: {
      "display": "inline-flex",
      "vertical-align": "top",
      "justify-content": "center"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-mine"
  }), _vm._v(" "), _c('div', {
    staticClass: "listVal",
    on: {
      "click": function($event) {
        return _vm.othersPhoneFn('show')
      }
    }
  }, [(_vm.others.state) ? _c('p', [_vm._v("为别人叫")]) : _c('p', [_vm._v(_vm._s(_vm.others.recordPhone))])])]), _vm._v(" "), _c('span', {
    staticClass: "list listAc",
    staticStyle: {
      "display": "inline-flex",
      "vertical-align": "top",
      "justify-content": "center"
    },
    on: {
      "click": _vm.selectTimeFn
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shijian1"
  }), _c('p', [_vm._v(_vm._s(_vm.startTime.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "totalNum clear"
  }, [_c('div', {
    staticClass: "row",
    on: {
      "click": _vm.chooseDriverFn
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', [_vm._v("选择")]), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.driverNumber))]), _c('span', [_vm._v("位司机")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('xk-coupon-select', {
    attrs: {
      "type": 'daijia',
      "data": _vm.djCoupnsGetter
    },
    on: {
      "click": _vm.couponSlelectFn
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "totalNum"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "line-height": "4.5rem"
    },
    on: {
      "click": _vm.detailsBoxFn
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.budgetFee) ? _c('span', [_vm._v(_vm._s(_vm.loginData && _vm.loginData.passenger ? '约' : '起步价'))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.budgetFee))]), _vm._v(" "), (_vm.budgetFee) ? _c('span', [_vm._v("元")]) : _vm._e(), _vm._v(" "), (_vm.budgetFee) ? _c('i', {
    staticClass: "iconfont icon-iconfontyiwen"
  }) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "callOutBut"
  }, [(!_vm.enterprise_id) ? _c('button', {
    class: {
      disable: _vm.loadState
    },
    attrs: {
      "disabled": _vm.loadState
    },
    on: {
      "click": function($event) {
        return _vm.callCarFn('private')
      }
    }
  }, [_vm._v("\n        一键下单\n      ")]) : _vm._e(), _vm._v(" "), (_vm.enterprise_id) ? _c('button', {
    class: {
      disable: _vm.loadState
    },
    attrs: {
      "disabled": _vm.loadState
    },
    on: {
      "click": function($event) {
        return _vm.callCarFn('private')
      }
    }
  }, [_vm._v("\n        个人出行\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.adds.endAdd.endLat && _vm.enterprise_id && _vm.ygcx && (_vm.is_fixed_price == 1)) ? _c('button', {
    class: {
      disable: _vm.loadState || _vm.enterpriseDisabled
    },
    attrs: {
      "disabled": _vm.loadState || _vm.enterpriseDisabled
    },
    on: {
      "click": function($event) {
        return _vm.callCarFn('official')
      }
    }
  }, [_vm._v("因公出行(一口价0元)\n      ")]) : _vm._e(), _vm._v(" "), (_vm.adds.endAdd.endLat && _vm.enterprise_id && _vm.ygcx && (_vm.is_fixed_price == 1)) ? _c('button', {
    class: {
      disable: _vm.loadState || _vm.enterpriseDisabled
    },
    attrs: {
      "disabled": _vm.loadState || _vm.enterpriseDisabled
    },
    on: {
      "click": function($event) {
        return _vm.callCarFn('official')
      }
    }
  }, [_vm._v("因公出行(一口价" + _vm._s(_vm.money) + "元)\n      ")]) : _vm._e(), _vm._v(" "), (_vm.adds.endAdd.endLat && _vm.enterprise_id && _vm.ygcx && (_vm.is_fixed_price !== 1)) ? _c('button', {
    class: {
      disable: _vm.loadState || _vm.enterpriseDisabled
    },
    attrs: {
      "disabled": _vm.loadState || _vm.enterpriseDisabled
    },
    on: {
      "click": function($event) {
        return _vm.callCarFn('official')
      }
    }
  }, [_vm._v("因公出行(可抵扣)\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.adds.endAdd.endLat && _vm.enterprise_id && _vm.ygcx && (_vm.is_fixed_price !== 1)) ? _c('button', {
    class: {
      disable: _vm.loadState || _vm.enterpriseDisabled
    },
    attrs: {
      "disabled": _vm.loadState || _vm.enterpriseDisabled
    },
    on: {
      "click": function($event) {
        return _vm.callCarFn('official')
      }
    }
  }, [_vm._v("因公出行(可抵扣)\n      ")]) : _vm._e(), _vm._v(" "), (_vm.is_deduction === 2) ? _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("\n        您尚未开启企业优惠抵扣权限，请联系管理员")]) : _vm._e()]), _vm._v(" "), (_vm.others.showState) ? _c('xk-input-box', {
    ref: "othersPhone",
    attrs: {
      "title": "乘车人电话"
    },
    on: {
      "click": _vm.othersPhoneFn
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.others.othersPhone),
      expression: "others.othersPhone"
    }],
    staticClass: "othersPhoneInput",
    attrs: {
      "placeholder": "输入乘车人电话"
    },
    domProps: {
      "value": (_vm.others.othersPhone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.others, "othersPhone", $event.target.value)
      }, _vm.othersPhoneCheck]
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.datePickerState) ? _c('xk-date-picker-mod', {
    ref: "DatePicker",
    on: {
      "click": _vm.DatePickerFn
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.unfilledOrderState && _vm.unfilledOrderState.daijia && _vm.unfilledOrderFn.length > 0) ? _c('xk-unfilled-order-mod', {
    attrs: {
      "data": _vm.unfilledOrderFn ? _vm.unfilledOrderFn : null,
      "title": '代驾'
    },
    on: {
      "close": _vm.unfilledOrdercCloseFn
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e(), _vm._v(" "), (_vm.feeObj) ? _c('Xk-detailsBox', {
    ref: "detailsBox",
    staticClass: "costBox",
    attrs: {
      "title": '费用详情'
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "List"
  }, [_c('ul', [_c('li', {
    staticClass: "clear"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("总价")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.feeObj.total_fee / 100))]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])])]), _vm._v(" "), (_vm.feeObj.distance_fee) ? _c('li', {
    staticClass: "clear"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("里程费")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.feeObj.distance_fee / 100))]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])])]) : _vm._e(), _vm._v(" "), (_vm.feeObj.time_fee) ? _c('li', {
    staticClass: "clear"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("时间费")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.feeObj.time_fee / 100))]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "clear"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("起步价")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.feeObj.start_price / 100))]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "introduce",
    staticStyle: {
      "max-height": "40vh",
      "overflow-y": "auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.budgetFeeRemark)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('xk-my-picker', {
    attrs: {
      "showMyPicker": _vm.visible,
      "pickItem": _vm.slots,
      "title": "选择司机人数"
    },
    on: {
      "sureAction": _vm.sureSelectCar,
      "cancelAction": _vm.cancleSelectCar
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95b0977e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/daijia/daijia.vue
// module id = 556
// module chunks = 0